// src/components/recheck/footerButton.js
//
// The re-check footer's text buttons (Previous, Next, Correct position,
// Discard position, the reject note's Cancel): primitives.css's small outlined
// button, so each reads as a control rather than a hint, with the keyboard
// focus ring AiDashboardCard uses. Hover and disabled come with .op-btn.
export const FOOTER_BUTTON = "op-btn op-btn--sm focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-action/70";
